import React from 'react'
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from 'reactstrap';

const DownloadToolTip = (props) => {
    return (
        <>
            <Link to="#" onClick={props.onClick} className="text-dark"><i class="fa fa-download" id='Download' aria-hidden="true"></i></Link>
            <UncontrolledTooltip placement={props.placement} target="Download">
                {props.title}
            </UncontrolledTooltip>
        </>
    )
}

export default DownloadToolTip